import { render, staticRenderFns } from "./workshopBanner.vue?vue&type=template&id=31efc5f5&scoped=true&"
import script from "./workshopBanner.vue?vue&type=script&lang=js&"
export * from "./workshopBanner.vue?vue&type=script&lang=js&"
import style0 from "./workshopBanner.vue?vue&type=style&index=0&id=31efc5f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31efc5f5",
  null
  
)

export default component.exports